import React from 'react';

import { useAssigneePicker } from '@adsk/alloy-assignee-picker';
import Dropdown from '@adsk/alloy-react-dropdown';
import Portal from '@adsk/alloy-react-portal';

const FormsAssigneePicker = ({
  selection,
  disabled,
  disabledIds = {},
  defaultIsOpen,
  optionsOrder,
  optionsFilter,
  onChange,
}) => {
  const { dropdownProps } = useAssigneePicker({
    userOptionValue: 'id',
    optionsOrder,
    optionsFilter,
  });

  return (
    <Dropdown
      {...dropdownProps}
      isAutocomplete
      disabled={disabled}
      defaultIsOpen={defaultIsOpen}
      initialSelectedItem={dropdownProps.groupedItems
        .find((group) => group.group === selection.group)
        ?.items?.find((item) => item.value === selection.value)}
      isItemDisabled={(item) => item.value && !!disabledIds[item.value]} // works for disabling both tags and items
      onSelectedItemChange={({ selectedItem }) => onChange(selectedItem)}
      renderMenu={(menuProps, virtualProps) => (
        <Portal container={document.body}>
          {dropdownProps.renderMenu(menuProps, virtualProps)}
        </Portal>
      )}
      style={{ width: '100%' }}
    />
  );
};

export default FormsAssigneePicker;
